/**
 * @Component ProgressBar
 * @Type 进度条组件
 * @Author 瞿龙俊 - qulongjun@shine.design
 * @Date 2019-03-25 18:50
 */

/** 进度条容器 */
export {default as Progress} from './Progress';
/** 进度条项 */
export {default as Bar} from './Bar';
